<template>
  <v-card @click="view(resource)" :href="itemLink" target="_blank">
    <v-card-title class="pb-0">{{ $t("Uusi tiedosto lisätty") }}</v-card-title>
    <v-list two-line>
      <template>
        <v-list-item :key="resource.title" target="_blank">
          <v-list-item-avatar tile>
            <v-icon v-if="resource.resource_type == 1" size="32">
              {{ icons.mdiAttachment }}
            </v-icon>
            <v-icon v-else size="32">{{ icons.mdiLink }}</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="text-lg mb-1">
              {{ resource.title }}
            </v-list-item-title>

            <v-list-item-subtitle>
              {{ resource.description }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-list-item-action-text>
              <v-chip small>
                {{ resource.group_name }}
              </v-chip>
            </v-list-item-action-text>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import api from "@/api";
import download from "downloadjs";
import { mdiLink, mdiAttachment } from "@mdi/js";
import { computed } from "@vue/composition-api";

export default {
  props: ["resource"],
  setup(props) {
    const itemLink = computed(() => {
      if (props.resource.resource_type == 1) return null;
      return props.resource.link;
    });

    const view = async (resource) => {
      if (props.resource.resource_type == 1) {
        const response = await api.downloadResource(props.resource.id);

        download(response.data, props.resource.filename);
      }
    };

    return {
      itemLink,
      view,
      icons: {
        mdiLink,
        mdiAttachment,
      },
    };
  },
};
</script>

<style></style>
